<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">收款方式名称</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.pa_name" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">计算起始日</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" v-model="form.pa_beginby">
              <option :value="0">单据日</option>
              <option :value="1">单据日月初</option>
              <option :value="2">单据日月末</option>
              <option :value="3">单据日月中</option>
              <option :value="4">单据日次月初</option>
              <option :value="5">月结日</option>
              <option :value="6">单据日次月末</option>
              <option :value="7">半月结</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">账期天数</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.pa_dayadd" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">延迟天数</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.pa_delay" placeholder="请填写" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="onSave"
      >保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        v-if="form.id"
        @click="setStatus"
      >{{ form.pa_status == '已启用' ? '禁用' : '启用' }}</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_warnning"
        style="color: #ff6666;"
        v-if="form.id"
        @click="onRemove"
      >删除</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >返回</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  },
  data() {
    const form = Object.assign({}, this.initData) || {
      id: 0,
      pa_beginby: 0,
      pa_dayadd: 0,
      pa_delay: 0,
      pa_endday: null,
      pa_name: ""
    }

    return {
      form
    }
  },
  methods: {
    onSave() {
      var me = this,
        main = me.form;

      if (!main.pa_name) {
        me.$weui.topTips("请填写收款方式名称", 2000);
      } else if (!main.pa_dayadd) {
        me.$weui.topTips("请填写账期天数", 2000);
      } else if (!main.pa_delay) {
        me.$weui.topTips("请填写延期天数", 2000);
      } else {
        me.save();
      }
    },
    save() {
      var me = this;

      me.$loading({
        url: "/api/document/paymentsrec/save",
        method: "POST",
        jsonData: me.form
      }).then(function(res) {
        if (res.success) {
          me.$router.back();
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    setStatus() {
      var me = this,
        id = me.form.id;
      me.$loading({
        url: "/api/document/paymentsrec/setStatus/" + id,
        method: "POST"
      }).then(function(res) {
        if (res.success) {
          me.$weui.toast("操作成功", 2000);
          me.$router.back();
        } else {
          me.$weui.topTips("操作失败: " + res.message, 3000);
        }
      }).catch(function() {
        me.$weui.topTips("操作失败", 3000);
      });
    },
    onRemove() {
      var me = this

      me.$weui.confirm('确认删除吗？', function () {
        me.remove()
      });
    },
    remove() {
      var me = this,
        id = me.form.id;

      me.$loading({
        url: "/api/document/paymentsrec/delete/" + id,
        method: "POST"
      }).then(function(res) {
        if (res.success) {
          me.$weui.toast("操作成功", 2000);
          me.$router.back();
        } else {
          me.$weui.topTips("操作失败: " + res.message, 3000);
        }
      }).catch(function() {
        me.$weui.topTips("操作失败", 3000);
      });
    }
  }
};
</script>